export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Thoroughly Vetted Professionals',
      description: 'Every contractor in our directory undergoes comprehensive verification including license validation, insurance confirmation, background checks, and reference verification. We only feature contractors who meet our strict quality standards and maintain excellent reputations in the El Paso community.'
    },
    {
      icon: 'ri-star-line',
      title: 'Verified Customer Reviews',
      description: 'Read authentic reviews from real El Paso homeowners who have worked with our featured contractors. Our review system ensures transparency and helps you make informed decisions based on actual project experiences, quality of work, communication, and overall satisfaction.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Competitive Pricing Transparency',
      description: 'Compare quotes from multiple qualified contractors to ensure fair pricing for your project. Our platform promotes competitive rates while maintaining quality standards. Get detailed estimates that break down costs for materials, labor, and timelines so you can budget confidently.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Local Expertise &amp; Support',
      description: 'Our contractors understand El Paso\'s unique challenges including desert climate considerations, local building codes, soil conditions, and water conservation requirements. They bring specialized knowledge that ensures your project is completed correctly the first time with materials and methods suited to our environment.'
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Response Times',
      description: 'Connect with available contractors quickly. Most professionals in our network respond to inquiries within 24 hours and can provide estimates within days. Whether you need emergency repairs or are planning a major renovation, our contractors prioritize timely communication and project scheduling.'
    },
    {
      icon: 'ri-award-line',
      title: 'Quality Guarantee',
      description: 'Work with confidence knowing our featured contractors stand behind their work with warranties and guarantees. We monitor contractor performance and customer satisfaction to maintain the highest standards. If issues arise, our support team helps facilitate resolution to ensure your complete satisfaction.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why El Paso Homeowners Choose Our Directory
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Finding reliable contractors shouldn't be stressful. We've built a trusted platform that connects El Paso homeowners with qualified professionals who deliver exceptional results. Here's what sets us apart from other contractor directories and referral services.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg mb-4">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-gray-50 to-teal-50 rounded-xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                How Our Vetting Process Works
              </h3>
              <div className="space-y-4 text-sm text-gray-700 leading-relaxed">
                <p>
                  <strong className="text-gray-900">Step 1: License &amp; Insurance Verification</strong><br />
                  We verify all contractors hold current licenses required by the State of Texas and City of El Paso. We confirm general liability insurance, workers' compensation coverage, and bonding where applicable.
                </p>
                <p>
                  <strong className="text-gray-900">Step 2: Background &amp; Reference Checks</strong><br />
                  Each contractor undergoes background screening and we contact previous clients to verify work quality, professionalism, and reliability. We check for complaints with the Better Business Bureau and local consumer protection agencies.
                </p>
                <p>
                  <strong className="text-gray-900">Step 3: Portfolio Review</strong><br />
                  We examine completed projects to assess quality standards, attention to detail, and range of capabilities. Contractors must demonstrate consistent excellence across multiple projects.
                </p>
                <p>
                  <strong className="text-gray-900">Step 4: Ongoing Performance Monitoring</strong><br />
                  We continuously monitor customer reviews, complaint resolution, and overall satisfaction. Contractors who fail to maintain our standards are removed from the directory.
                </p>
              </div>
            </div>
            <div className="relative h-96 rounded-xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/877858e9c0f64b1f7997960b954f4dde.jpg" 
                alt="Quality vetting process"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
